import { OnboardingFlowGroup, type OnboardingGuidanceFlow, type OnboardingGuidanceFlowWithHandler } from './types';

/**
 * Query parameter names used by onboarding guidance (onboardingFlow, step).
 * Used when comparing URLs to allow navigation when only the onboarding step changes.
 */
export const ONBOARDING_QUERY_PARAMS = ['onboardingFlow', 'step'] as const;

/**
 * Union type representing either a static flow or a flow with an onClick handler.
 */
export type FlowType = OnboardingGuidanceFlow | OnboardingGuidanceFlowWithHandler;

/**
 * Human-readable labels for each flow group, used in filter buttons and section headings.
 * TypeScript will error if any enum value is missing from this record.
 */
export const GROUP_LABELS: Record<OnboardingFlowGroup, string> = {
  [OnboardingFlowGroup.FeatureFlags]: 'Feature Flags',
  [OnboardingFlowGroup.AiConfigs]: 'Configs',
  [OnboardingFlowGroup.Experimentation]: 'Experimentation',
  [OnboardingFlowGroup.Observability]: 'Observability',
};

/**
 * Display order for flow groups in the UI.
 * Uses Object.values to ensure all enum values are included.
 */
export const GROUP_ORDER: OnboardingFlowGroup[] = [
  OnboardingFlowGroup.FeatureFlags,
  OnboardingFlowGroup.AiConfigs,
  OnboardingFlowGroup.Experimentation,
  OnboardingFlowGroup.Observability,
];
